<template>
  <el-dialog title="店员详情" width="80%" :visible.sync="dialogVisible" :fullscreen="device==='mobile'" @close="dialogClose">
    <el-form ref="detailForm" v-loading="loading" element-loading-text="加载中..." :model="detail" :rules="rules" label-width="100px" :label-position="device === 'mobile' ? 'top' : 'right'">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item style="display: none;">
            <el-input v-model="detail.userId" />
          </el-form-item>
          <el-form-item label="用户昵称" prop="userId">
            <el-input v-model="detail.nickName" placeholder="请输入用户昵称或手机号查找">
              <el-button slot="append" icon="el-icon-search" @click.stop="searchUser" />
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="店员名称" prop="userName">
            <el-input v-model="detail.userName" placeholder="请输入店员名称" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="detail.mobile" type="number" maxlength="11" placeholder="请输入店员手机号" />
          </el-form-item>
        </el-col>
        <el-col v-if="!detail.id" :xs="24" :sm="12" :md="6">
          <el-form-item label="登录密码" prop="password">
            <el-input v-model="detail.password" placeholder="请输入登录密码" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :xs="8" :sm="6">
          <el-form-item label="系统管理员" prop="isAdmin" label-position="right">
            <el-switch v-model="detail.isAdmin" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="8" :sm="6">
          <el-form-item label="核销权限" prop="isVerify" label-position="right">
            <el-switch v-model="detail.isVerify" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </el-col> -->
        <el-col :xs="8" :sm="6">
          <el-form-item label="状态" prop="status" label-position="right">
            <el-switch v-model="detail.status" :width="60" class="rectangle" active-color="#13ce66" :active-value="1" :inactive-value="0" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label-width="0px">
            <ouer-transfer
              v-model="selectedStores"
              height="540px"
              :data="stores"
              :left-props="leftProps"
              :right-props="rightProps"
              :button-texts="['授权', '移除']"
              :headers="['可选商家', '已授权商家']"
              @moveToRight="handleMoveToRight"
              @moveToLeft="handleMoveToLeft"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">提交保存</el-button>
    </span>

    <member-info v-if="showMemberInfo" :show.sync="showMemberInfo" :data="memberInfo" title="用户信息" @close="handleCancel" @submit="handleConfirm" />
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { searchByKeyword } from '@/api/member'
import { getEmployeeDetail, submitEmployee } from '@/api/store'

export default {
  name: 'EmployeeDetail',
  components: {
    MemberInfo: () => import('@/components/MemberInfo'),
    OuerTransfer: () => import('@/components/OuerTransfer')
  },
  props: {
    show: Boolean,
    stores: {
      type: Array,
      default: () => []
    },
    employeeId: {
      type: String,
      default: ''
    },
    memberId: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default: null
    },
    shopInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      detail: {
        status: 1,
        isAdmin: 0
      },
      loading: false,
      memberInfo: {},
      dialogVisible: false,
      showMemberInfo: false,
      selectedStores: [],
      rules: {
        userId: [{ required: true, message: '请输入昵称或手机号查找用户', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入店员名称', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
      },
      leftProps: {
        key: 'id',
        label: [{
          text: '商家名称',
          type: 'search'
        }],
        prop: ['shopName'],
        searchKey: 'shopName'
      },
      rightProps: {
        key: 'shopId',
        label: ['商家名称', '是否店长', '核销权限'],
        prop: [{
          text: 'shopName',
          type: 'text'
        }, {
          text: 'isManager',
          type: 'switch',
          align: 'center',
          width: '70'
        }, {
          text: 'verifyStatus',
          type: 'switch',
          align: 'center',
          width: '70'
        }]
      }
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    }
  },
  mounted() {
    if (this.employeeId || this.memberId) {
      this.selectedStores = []
      this.loadData()
    } else if (this.shopInfo) {
      this.selectedStores.push(this.shopInfo)
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    },
    loadData() {
      getEmployeeDetail(this.employeeId, this.memberId).then(response => {
        if (response) {
          this.detail = Object.assign({}, response)
          if (response.staffList && response.staffList.length) {
            const staffList = response.staffList.filter(item => item.shopId && item.shopName)
            this.selectedStores = [...staffList]
          }
        } else if (this.userInfo) {
          this.detail = {
            status: 1,
            userId: this.userInfo.id,
            avatar: this.userInfo.avatar,
            mobile: this.userInfo.mobile,
            nickName: this.userInfo.nickName,
            userName: this.userInfo.nickName
          }
        }
        if (this.shopInfo && this.shopInfo.shopId && !this.detail.isAdmin) {
          const index = this.selectedStores.findIndex(item => item.shopId === this.shopInfo.shopId)
          if (index < 0) this.selectedStores.push(this.shopInfo)
        }
      })
    },
    searchUser() {
      this.loading = true
      searchByKeyword({ keyword: this.detail.nickName.trim() }).then(response => {
        this.memberInfo = response
      }).catch(() => {}).finally(() => {
        setTimeout(() => {
          this.loading = false
          this.showMemberInfo = true
        }, 1000)
      })
    },
    handleCancel() {
      this.showMemberInfo = false
    },
    handleConfirm() {
      this.detail.userId = this.memberInfo.id
      this.detail.avatar = this.memberInfo.avatar
      this.detail.nickName = this.memberInfo.nickName
      if (this.memberInfo.mobile && !this.detail.mobile) this.detail.mobile = this.memberInfo.mobile
      this.$refs.detailForm.clearValidate()
      this.showMemberInfo = false
    },
    handleMoveToRight(sources) {
      const targets = sources.map(item => {
        return {
          id: '',
          employeeId: '',
          isManager: 0,
          verifyStatus: 1,
          shopId: item.id,
          shopName: item.shopName
        }
      })
      this.selectedStores = this.selectedStores.concat(targets)
    },
    handleMoveToLeft(targets) {
      const sources = [...this.selectedStores]
      targets.forEach(item => {
        const index = sources.findIndex(source => item.shopId === source.shopId)
        if (index >= 0) sources.splice(index, 1)
      })
      this.selectedStores = [...sources]
    },
    handleSubmit() {
      // console.log(this.selectedStores)
      if (!this.detail.isAdmin && !this.selectedStores.length) return this.$message.warning('请选择要授权的商家')
      this.$refs.detailForm.validate(valid => {
        if (!valid) return this.$message.error('提交保存失败，请输入带“*”的数据')
        this.detail.staffList = this.selectedStores.map(item => ({
          shopId: item.shopId,
          isManager: item.isManager,
          verifyStatus: item.verifyStatus
        }))
        submitEmployee(this.detail).then(response => {
          if (response) {
            this.$message.success('店员资料保存成功')
            this.dialogClose()
            this.$emit('submit')
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-transfer {
  display: flex;
  justify-content: space-between;

  ::v-deep {
    .el-transfer-panel {
      flex: 1;
      .el-transfer-panel__body {
        display: flex;
        height: 500px;
        flex-direction: column;

        .el-transfer-panel__list {
          flex: 1;
          &.el-checkbox-group {
            display: block;
          }
        }
      }
    }
    .el-transfer__buttons {
      display: inline-flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .el-transfer__button {
        display: inline-flex;
        width: 80px;

        &:last-child {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
